// src/store/slices/ui/UISlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { initialUiState, type UiConfirmState, type UiState } from '@/types/ui.types';

export const uiSlice = createSlice({
  name: 'ui',
  initialState: initialUiState,
  reducers: {
    openModal: (state, action: PayloadAction<UiState['modal']>) => {
      const { payload } = action;
      state.modal = payload;
    },
    closeModal: (state) => {
      state.modal = null;
    },
    openConfirm: (state, action: PayloadAction<UiConfirmState>) => {
      const { payload } = action;
      state.confirm = payload;
    },
    closeConfirm: (state) => {
      state.confirm = null;
    },
    setShowLoader: (state) => {
      state.showLoader = true;
    },
    setHideLoader: (state) => {
      state.showLoader = false;
    },
    setErrorMessage: (state, action: PayloadAction<string | null>) => {
      const { payload } = action;
      state.errorMessage = payload;
    },

    // ---------------- polling modal reducers ----------------
    setPollingSuccess: (
      state,
      action: PayloadAction<{ title: string; message: string; resourceUrl?: string | null }>
    ) => {
      state.pollingModal = {
        type: 'success',
        title: action.payload.title,
        message: action.payload.message,
        resourceUrl: action.payload.resourceUrl ?? null,
        details: null,
      };
    },

    setPollingError: (
      state,
      action: PayloadAction<{ title: string; message: string; details?: Record<string, unknown> | null }>
    ) => {
      state.pollingModal = {
        type: 'error',
        title: action.payload.title,
        message: action.payload.message,
        resourceUrl: null,
        details: action.payload.details ?? null,
      };
    },

     clearPollingModal: (state) => {
      state.pollingModal = { type: null };
    },
  },
});

const { actions } = uiSlice;
export const {
  openModal,
  closeModal,
  openConfirm,
  closeConfirm,
  setShowLoader,
  setHideLoader,
  setErrorMessage,
  setPollingSuccess,
  setPollingError,
  clearPollingModal,
} = actions;

export default uiSlice.reducer;
